export default "/images/vendor/flag-icon-css/flags/1x1/ye.svg?9b186a8be867d7cb136d2dcdb89d8d2b";